import { APP_NAME, metafieldFields } from "../fields";
import { commonCustomerProductFields } from "../product-gql";

const wishListMetafieldName: Record<string, string> = {
  tune: '(namespace: "wish_list", key: "products")',
  yeseyesee: '(namespace: "info", key: "wishlist")',
  thisisneverthat: '(namespace: "info", key: "wishlist")',
  khakis: '(namespace: "info", key: "wishlist")',
  sunlove: '(namespace: "info", key: "wishlist")',
  wellbeingexpress: '(namespace: "info", key: "wishlist")',
};

export const wishListMetafield = {
  operation: {
    name: `metafield${wishListMetafieldName[APP_NAME]}`,
    alias: "wishlist",
  },
  fields: [
    ...metafieldFields,
    {
      operation: "references(first: 250)",
      fields: [
        {
          edges: [
            {
              node: [
                {
                  operation: "Product",
                  fields: commonCustomerProductFields,
                  fragment: true,
                },
              ],
            },
          ],
        },
      ],
      variables: {},
    },
  ],
  variables: {},
};

const genderMetafieldName: Record<string, string> = {
  tune: '(namespace: "custom", key: "gender")',
  yeseyesee: '(namespace: "info", key: "gender")',
  thisisneverthat: '(namespace: "info", key: "gender")',
  khakis: '(namespace: "info", key: "gender")',
  sunlove: '(namespace: "info", key: "gender")',
  wellbeingexpress: '(namespace: "info", key: "gender")',
};

export const genderMetafield = {
  operation: {
    name: `metafield${genderMetafieldName[APP_NAME]}`,
    alias: "gender",
  },
  fields: metafieldFields,
  variables: {},
};

const birthMetafieldName: Record<string, string> = {
  tune: '(namespace: "custom", key: "birth")',
  yeseyesee: '(namespace: "info", key: "birth")',
  thisisneverthat: '(namespace: "info", key: "birth")',
  khakis: '(namespace: "info", key: "birth")',
  sunlove: '(namespace: "info", key: "birth")',
  wellbeingexpress: '(namespace: "info", key: "birth")',
};

export const birthMetafield = {
  operation: {
    name: `metafield${birthMetafieldName[APP_NAME]}`,
    alias: "birth",
  },
  fields: metafieldFields,
  variables: {},
};

const heightMetafieldName: Record<string, string> = {
  tune: '(namespace: "custom", key: "height")',
  yeseyesee: '(namespace: "info", key: "height")',
  thisisneverthat: '(namespace: "info", key: "height")',
  khakis: '(namespace: "info", key: "height")',
  jknd: '(namespace: "info", key: "height")',
  sunlove: '(namespace: "info", key: "height")',
  wellbeingexpress: '(namespace: "info", key: "height")',
};

export const heightMetafield = {
  operation: {
    name: `metafield${heightMetafieldName[APP_NAME]}`,
    alias: "height",
  },
  fields: metafieldFields,
  variables: {},
};

const weightMetafieldName: Record<string, string> = {
  tune: '(namespace: "custom", key: "weight")',
  yeseyesee: '(namespace: "info", key: "weight")',
  thisisneverthat: '(namespace: "info", key: "weight")',
  khakis: '(namespace: "info", key: "weight")',
  jknd: '(namespace: "info", key: "weight")',
  sunlove: '(namespace: "info", key: "weight")',
  wellbeingexpress: '(namespace: "info", key: "weight")',
};

export const weightMetafield = {
  operation: {
    name: `metafield${weightMetafieldName[APP_NAME]}`,
    alias: "weight",
  },
  fields: metafieldFields,
  variables: {},
};

export const cardInfoMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "card_info")',
    alias: "cardInfo",
  },
  fields: metafieldFields,
  variables: {},
};
